var map = {
	"./logo-bocconi.svg": 3884,
	"./logo-caltech.svg": 3885,
	"./logo-cambridge.svg": 3886,
	"./logo-edinburgh.svg": 3887,
	"./logo-oxford.svg": 3888,
	"./logo-texas.svg": 3889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3883;